import React, { FunctionComponent } from 'react';
import Style from './ZppLandingPage.style';
import { Menu } from 'View/Component';
import { HeaderSection, AppDescriptionSection, RefundCheckFormSection, HowToSection } from './Sections';
import { RouteComponentProps } from '@reach/router';
import { handleMobileScrollToForm } from 'utils/mobileScrolls';

export const ZppLandingPage: FunctionComponent<RouteComponentProps> = () => {
  const formRef = React.useRef<HTMLDivElement>(null);

  const scrollToFormSection = () => {
    handleMobileScrollToForm(formRef);
  };

  return (
    <Style>
      <Menu noNavigation />
      <HeaderSection startNowButton={scrollToFormSection} />
      <AppDescriptionSection startNowButton={scrollToFormSection} />
      <RefundCheckFormSection ref={formRef} />
      <HowToSection startNowButton={scrollToFormSection} />
    </Style>
  );
};
